import React from "react";
import SvgIconComponent from "../utils/SvgIconComponent";

function PersonIcon({color, className, size}) {
  return (
    <SvgIconComponent size={size} color={color}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M16.12 12c-.34.32-.697.6-1.071.83-.944.619-1.98.942-3.052.942-1.586 0-3.005-.695-4.14-1.765A12.126 12.126 0 000 23.369c0 .354.28.631.624.631h22.752c.35 0 .624-.278.624-.63 0-.045 0-.09-.013-.127A12.119 12.119 0 0016.12 12zM12 12c.886 0 1.752-.25 2.564-.73a6.268 6.268 0 001.678-1.394c.02-.018.04-.036.053-.06C17.36 8.555 18 6.936 18 5.482 18 2.459 15.31 0 12 0S6 2.458 6 5.483C6 8.495 8.624 12 12 12z"
      ></path>
    </svg>
    </SvgIconComponent>
  );
}

export default PersonIcon;